$(document).ready(function () {
  let submitButton = $('#subscribe_submit_button');
  let subscriptionAmountField = $("#subscription_amount_field");
  let warningModal = $('#NonInformedProfileWarningModal');

  submitButton.click(function() {
    amount = subscriptionAmountField.val()

    if (!subscriptionAmountField[0].checkValidity()) {
      document.getElementById("fields_errors").innerHTML = subscriptionAmountField[0].validationMessage;
      return false;
    } else {
      document.getElementById("fields_errors").innerHTML = "";
    }

    Rails.ajax({
      type: "GET",
      url: subscriptionAmountField.data("url"),
      data: '&[amount]=' + amount,
      dataType: "json",
      success: function(response) {
      let warning_modal_required = response["warning_modal_required"]
        if (warning_modal_required) {
          warningModal.modal('show');
        } else {
          $('#subscribeModal').modal('show');
        }
      },
      error: function(response) {
        document.getElementById("fields_errors").innerHTML = "Une erreur s'est produite, veuillez réessayer.";
      }
    });
  });

  warningModal.on("shown.bs.modal", function() {
    $('#NonInformedProfileWarningModal :input').prop('disabled', false);
  });

  warningModal.on("hide.bs.modal", function() {
    $('#NonInformedProfileWarningModal :input').prop('disabled', true);
  });
});
